export const menu = {
  manage: 'Zarządzaj',
  configuration: 'Szablony konfiguracji',
  configurationDesc: 'Podglądaj i zarządzaj szablonami konfiguracji',
  configurationNew: 'Utwórz nowy szablon konfiguracji',
  configurationNewDesc: 'Utwórz nowy szablon konfiguracji',
  users: 'Użytkownicy',
  files: 'Pliki',
  filesDesc: 'Zarządzaj i podglądaj pliki aplikacji',
  statistics: 'Statystyki',
  statisticsDesc: 'Przeglądaj wykresy i dane statystyczne',
  roles: 'Role',
  rolesDesc: 'Zarządzaj rolami użytkowników',
  usersDesc: 'Zarządzaj użytkownikami',
  configurationFinished: 'Zakończone konfiguracje',
  configurationFinishedDesc: 'Podglądaj zakończone szablony konfiguracji',
  logsDesc: 'Przeglądaj logi zapytań i komend',
  criteriaDesc: 'Zdefiniuj możliwe przyszłe konfiguracje',
}
